import Vue from 'vue';
import { Name } from '../../public/my.env';

// Configurations for WebSocket URLs based on environment and protocol
const wsConfig = {
  st6: {
    https: 'wss://trainerapi-s1.liverunapp.com:3107/',
    http: 'ws://trainerapi-s1.liverunapp.com:3007/',
  },
  st5: {
    https: 'wss://trainerapi-s.liverunapp.com:3105/',
    http: 'ws://trainerapi-s.liverunapp.com:3005/',
  },
  st4: {
    https: 'wss://trainerapi.liverunapp.com:3104/',
    http: 'ws://trainerapi.liverunapp.com:3004/',
  },
  dev: {
    https: 'wss://localhost:4100/',
    http: 'ws://localhost:4000/',
  }
};

let socket = null;

const emitter = new Vue({
  data() {
    return {
      socketUrl: this.resolveWebSocketUrl(),
    };
  },
  methods: {
    resolveWebSocketUrl() {
      const protocol = window.location.protocol.includes('https') ? 'https' : 'http';
      return wsConfig[Name] && wsConfig[Name][protocol] ? wsConfig[Name][protocol] : 'ws://localhost:4000/';
    },
    connect() {
      if (socket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(socket.readyState)) {
        console.log('WebSocket is already connected or connecting.');
        return;
      }

      socket = new WebSocket(this.socketUrl);
      socket.onopen = () => this.$emit('open', 'Socket is open.');
      socket.onmessage = (msg) => this.$emit('message', msg.data);
      socket.onerror = (err) => this.$emit('error', err);
      socket.onclose = (err) => {
        this.$emit('close', 'Socket is closed.');
        socket = null; // Reset socket to null to allow reconnection
      };
    },
    send(message) {
      // Log the request being sent to socket
      console.log('SENDING REQUEST TO SOCKET', message);
      
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      } else {
        console.log('Socket is not open. Connecting...');
        this.connect();
        setTimeout(() => {
          if (socket.readyState === WebSocket.OPEN) {
            console.log('SENDING REQUEST TO SOCKET (after reconnect)', message);
            socket.send(JSON.stringify(message));
          } else {
            console.log('Failed to open socket after waiting.');
          }
        }, 2000); // Consider a more robust retry mechanism
      }
    },
    close() {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    },
  },
  created() {
    this.connect(); // Optionally auto-connect on creation
  },
});

export default emitter;



// WEBPACK FOOTER //
// ./src/services/Socket.js